// ### STYLE SCSS ###
import './../../scss/2026/style.scss';

import { WCAG } from "rytm-wcag";
import { initCommon } from './shared/common'
import { initASwap } from './aswap'

WCAG.init();
// initCommon()
setTimeout(() => {
  document.documentElement.classList.remove('index-loading');
}, 500);
initASwap();
initCommon();
